export const impactStats = [
  { label: 'Meals Served', value: '2.5M+', icon: 'ri-restaurant-line' },
  { label: 'Children Educated', value: '48,000+', icon: 'ri-book-open-line' },
  { label: 'Disasters Responded', value: '120+', icon: 'ri-first-aid-kit-line' },
  { label: 'Animals Rescued', value: '15,000+', icon: 'ri-heart-pulse-line' },
];

export const services = [
  {
    id: 'food-aid',
    title: 'Food Aid',
    description: 'Providing nutritious meals and food supplies to communities facing hunger and food insecurity.',
    icon: 'ri-restaurant-2-line',
    image: 'https://readdy.ai/api/search-image?query=warm%20humanitarian%20food%20aid%20volunteers%20distributing%20meals%20to%20families%20in%20need%2C%20golden%20hour%20lighting%2C%20documentary%20photography%20style%2C%20community%20kitchen%20helping%20people%2C%20warm%20orange%20tones%2C%20authentic%20emotional%20moment%2C%20professional%20photography&width=800&height=600&seq=food-001&orientation=landscape',
  },
  {
    id: 'education',
    title: 'Education Support',
    description: 'Building schools, providing scholarships, and delivering educational resources to underserved children.',
    icon: 'ri-graduation-cap-line',
    image: 'https://readdy.ai/api/search-image?query=children%20in%20a%20bright%20classroom%20learning%20with%20books%20and%20supplies%2C%20hopeful%20atmosphere%2C%20warm%20natural%20light%20streaming%20through%20windows%2C%20documentary%20style%20education%20scene%2C%20warm%20earthy%20tones%2C%20smiling%20young%20students&width=800&height=600&seq=edu-001&orientation=landscape',
  },
  {
    id: 'disaster',
    title: 'Disaster Relief',
    description: 'Rapid response teams delivering emergency supplies, shelter, and medical aid during natural disasters.',
    icon: 'ri-lifebuoy-line',
    image: 'https://readdy.ai/api/search-image?query=humanitarian%20disaster%20relief%20workers%20helping%20community%20after%20flood%2C%20volunteers%20carrying%20supplies%2C%20dramatic%20sky%20with%20hope%2C%20documentary%20photography%2C%20warm%20golden%20tones%20mixed%20with%20action%2C%20authentic%20rescue%20scene&width=800&height=600&seq=dis-001&orientation=landscape',
  },
  {
    id: 'pet-rescue',
    title: 'Pet Rescue',
    description: 'Rescuing abandoned and injured animals, providing veterinary care, and finding loving forever homes.',
    icon: 'ri-home-heart-line',
    image: 'https://readdy.ai/api/search-image?query=volunteer%20rescuing%20stray%20dogs%20and%20cats%20at%20animal%20shelter%2C%20warm%20compassionate%20scene%2C%20golden%20afternoon%20light%2C%20documentary%20style%20pet%20rescue%2C%20happy%20animals%20being%20cared%20for%2C%20warm%20earthy%20tones&width=800&height=600&seq=pet-001&orientation=landscape',
  },
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    role: 'Monthly Donor',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20friendly%20woman%20in%20her%2040s%20with%20warm%20smile%2C%20neutral%20background%2C%20soft%20studio%20lighting%2C%20approachable%20expression%2C%20clean%20minimal%20portrait&width=200&height=200&seq=ava-001&orientation=squarish',
    rating: 5,
    text: '"KELAB IKATAN BINA INSAN transformed our entire community. Their food program feeds over 300 families every week, and their education initiative helped my daughter finish school. This organization truly cares."',
  },
  {
    id: 2,
    name: 'David Chen',
    role: 'Volunteer since 2021',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20an%20asian%20man%20in%20his%2030s%20with%20confident%20smile%2C%20neutral%20background%2C%20soft%20studio%20lighting%2C%20approachable%20friendly%20expression%2C%20clean%20minimal%20portrait&width=200&height=200&seq=ava-002&orientation=squarish',
    rating: 5,
    text: '"Volunteering with the disaster relief team has been the most rewarding experience of my life. The organization is incredibly well-organized, and you can see the direct impact of every hour you give."',
  },
  {
    id: 3,
    name: 'Maria Gonzalez',
    role: 'Education Program Beneficiary',
    avatar: 'https://readdy.ai/api/search-image?query=professional%20headshot%20portrait%20of%20a%20latina%20woman%20in%20her%2020s%20with%20bright%20hopeful%20smile%2C%20neutral%20background%2C%20soft%20studio%20lighting%2C%20warm%20genuine%20expression%2C%20clean%20minimal%20portrait&width=200&height=200&seq=ava-003&orientation=squarish',
    rating: 5,
    text: '"Thanks to KELAB IKATAN BINA INSAN, I received a scholarship that allowed me to become the first in my family to attend university. Now I am a teacher giving back to my own community."',
  },
];

export const campaigns = [
  {
    id: 1,
    title: 'Emergency Flood Relief',
    description: 'Providing clean water, food, and shelter to families affected by recent flooding.',
    raised: 145000,
    goal: 200000,
    donors: 1240,
    image: 'https://readdy.ai/api/search-image?query=aerial%20view%20of%20flooded%20village%20with%20rescue%20boats%2C%20dramatic%20documentary%20photography%2C%20warm%20golden%20hour%20light%20reflecting%20on%20water%2C%20humanitarian%20crisis%20scene%20with%20hope%2C%20professional%20photojournalism&width=800&height=500&seq=cam-001&orientation=landscape',
  },
  {
    id: 2,
    title: 'Build a School Initiative',
    description: 'Constructing a new primary school in a rural community with 500 children.',
    raised: 89000,
    goal: 150000,
    donors: 856,
    image: 'https://readdy.ai/api/search-image?query=children%20walking%20to%20a%20newly%20built%20school%20in%20rural%20area%2C%20bright%20sunny%20day%2C%20hope%20and%20education%20theme%2C%20documentary%20style%20photography%2C%20warm%20natural%20tones%2C%20joyful%20atmosphere%2C%20professional%20shot&width=800&height=500&seq=cam-002&orientation=landscape',
  },
  {
    id: 3,
    title: 'Animal Shelter Expansion',
    description: 'Expanding our shelter to rescue and care for 200 more abandoned animals.',
    raised: 67000,
    goal: 100000,
    donors: 643,
    image: 'https://readdy.ai/api/search-image?query=happy%20rescued%20dogs%20and%20cats%20in%20a%20modern%20clean%20animal%20shelter%2C%20warm%20afternoon%20sunlight%20through%20windows%2C%20compassionate%20volunteers%20caring%20for%20animals%2C%20documentary%20style%2C%20warm%20earthy%20tones&width=800&height=500&seq=cam-003&orientation=landscape',
  },
];